import { deviceManagementDeveloperNavigation } from '../domain/navigation-developer.util';

export default deviceManagementDeveloperNavigation;
